export const backgroundShader = `
precision mediump float;

uniform vec2 offsets;
uniform int gridSize;
uniform int dotSize;
uniform vec3 backgroundColor;
uniform vec3 dotColor;

void main(){
  bool putPixel = false;

  float xpos = gl_FragCoord.x - offsets.x;
  float ypos = gl_FragCoord.y + offsets.y;

  float d1 = xpos / float(gridSize);
  int q1 = int(d1) * gridSize;
  int r1 = int(xpos - float(q1));

  float d2 = ypos / float(gridSize);
  int q2 = int(d2) * gridSize;
  int r2 = int(ypos - float(q2));

  if(r1 <= dotSize && r1 > 0 && r2 <= dotSize && r2 > 0){
    putPixel = true;
  }

  if(putPixel) {
    gl_FragColor = vec4(dotColor, 1.0);
  } else {
    gl_FragColor = vec4(backgroundColor, 1.0);
  }
}
`;
